import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllBlogs = () => apiClient.get(ENDPOINTS.BLOG.GET_ALL);

export const getBlogsForHome = () => apiClient.get(ENDPOINTS.BLOG.GET_FOR_HOME);

export const getBlogBySlug = (slug) => apiClient.get(`${ENDPOINTS.BLOG.BASE}/${slug}`);

export const createBlog = (formData) => apiClient.post(ENDPOINTS.BLOG.CREATE, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export const updateBlog = (id, formData) => apiClient.put(ENDPOINTS.BLOG.UPDATE(id), formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export const deleteBlog = (id) => apiClient.delete(ENDPOINTS.BLOG.DELETE(id));
